import qs from 'qs';
import { USER_TYPE } from 'types/Enum';
import { GenericResponse } from 'types/Response';
import {
  AddConsultantPayload,
  AddConsultantResponse,
  DeleteUserPayload,
  DeleteUserResponse,
  DisableUserPayload,
  DisableUserResponse,
  LoginPayload,
  LoginResponse,
  UpdatePasswordPayload,
  UpdatePasswordResponse,
  UsersListResponse,
} from 'types/services/Auth';
import axiosInstance from 'utils/axiosInstance';

const BASE_URL = `${process.env.REACT_APP_API_URL}/api/v1/user`;
class AuthService {
  async verify(): Promise<GenericResponse<null>> {
    const { data } = await axiosInstance.get(`${BASE_URL}/verifyToken`);

    return data;
  }

  async login(payload: LoginPayload): Promise<LoginResponse> {
    const headers: Record<string, string> = {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };
    const { data } = await axiosInstance.post(`${BASE_URL}/login`, payload, { headers });

    return data;
  }

  async createConsultant(
    payload: AddConsultantPayload
  ): Promise<AddConsultantResponse> {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/createConsultant`,
      payload
    );

    return data;
  }

  async updatePassword(
    payload: UpdatePasswordPayload
  ): Promise<UpdatePasswordResponse> {
    const { data } = await axiosInstance.put(
      `${BASE_URL}/updateConsultantPassword`,
      payload
    );

    return data;
  }

  async getUserByList(): Promise<UsersListResponse> {
    const { data } = await axiosInstance.get(
      `${BASE_URL}/getUsersList${qs.stringify(
        { type: 'CONSULTANT' as USER_TYPE },
        { addQueryPrefix: true }
      )}`
    );

    return data;
  }

  async disableUser(payload: DisableUserPayload): Promise<DisableUserResponse> {
    const { data } = await axiosInstance.put(
      `${BASE_URL}/disableUser`,
      payload
    );

    return data;
  }

  async enableUser(payload: DisableUserPayload): Promise<DisableUserResponse> {
    const { data } = await axiosInstance.put(`${BASE_URL}/enableUser`, payload);

    return data;
  }

  async deleteUser(payload: DeleteUserPayload): Promise<DeleteUserResponse> {
    const { data } = await axiosInstance.delete(
      `${BASE_URL}/deleteUser/${payload.id}`
    );

    return data;
  }
}

export const AuthServiceInstance = new AuthService();
